export const CHECK_EMPTY_STRING = (string) => {
    if (typeof string === "string") {
        return string.trim().length !== +0 ? false : true;
    }
    return true;
}